import React from 'react'
import styled from 'styled-components'
import { injectIntl } from 'gatsby-plugin-react-intl'
import { breakpoint } from '@configs/utilities'
import { color } from '@configs/utilities'
import ButtonsNavbar from '@components/ui/buttons/ButtonsNavbar'
import { generateAppLink } from '@configs/helpers'
import { useLocation } from '@reach/router'

const NavbarButtons = ({ intl }) => {
  const isDefaultLanguage = intl.defaultLocale === intl.locale
  const slug = useLocation().pathname.split('/')[isDefaultLanguage ? 1 : 2]

  const defaultButtonPageData = {
    path: 'signup',
    external: true,
    text: 'buttons.tryForFree',
  }

  const buttonPageData = [
    {
      slug: 'homepage1',
      external: false,
      path: '/pricing',
      text: 'buttons.getStarted',
    },
    {
      slug: 'homepage2',
      external: false,
      path: '/pricing2',
      text: 'buttons.getStarted',
    },
    {
      slug: 'homepage3',
      external: false,
      path: '/pricing',
      text: 'buttons.getStarted',
    },
    {
      slug: 'pricing2',
      external: true,
      path: '/signup',
      text: 'buttons.getStarted',
    },
  ]

  const pageData = buttonPageData.find((item) => item.slug === slug)
  const finalData = pageData ? pageData : defaultButtonPageData

  return (
    <NavbarButtonsWrapper>
      <ButtonsNavbar
        external
        href={generateAppLink('login', intl.locale)}
        buttonBackground={color.white}
        buttonColor={color.font}
        buttonText={intl.formatMessage({ id: 'buttons.logIn' })}
        smfontsize={'16px'}
        mdfontsize={'16px'}
        border={`inset 0 0 0 2px ${color.silver}`}
      />

      <ButtonsNavbar
        external={finalData.external}
        href={generateAppLink(finalData.path, intl.locale)}
        to={finalData.path}
        buttonText={intl.formatMessage({ id: finalData.text })}
        smfontsize={'16px'}
        mdfontsize={'16px'}
      />
    </NavbarButtonsWrapper>
  )
}

export default injectIntl(NavbarButtons)

const NavbarButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  @media screen and (min-width: ${breakpoint.lg}) {
    flex-direction: row;
    column-gap: 10px;
  }
`
